module.exports = __webpack_public_path__ + "static/media/AeroGCSInactive.ce3e54fe.png";